export default {
	dbFiltered (s, g) {
		return s.db
			.filter(d => !s.curation.map(c => c.tipoQuestaoId).includes(d.tipoQuestaoId))
			.filter(d => !s.object.map(o => o.tipoQuestaoId).includes(d.tipoQuestaoId))
	}
}
